import { render } from "./InstallWizardPhysicalInstallCard.vue?vue&type=template&id=5da0e06d"
import script from "./InstallWizardPhysicalInstallCard.vue?vue&type=script&lang=js"
export * from "./InstallWizardPhysicalInstallCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__